<template>
  <div style="position: relative">
    <div class="search flex">
      <span class="tit">权限管理</span>
      <div class="flex">
        <el-button v-show="activeTabName=='admin'" class="addBtn" @click="addAdmin" size="small">
          新增人员
        </el-button>
        <el-input class="addART"
                  placeholder="姓名"
                  v-model="searchKey"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>

      </div>
    </div>
    <el-tabs v-model="activeTabName" class="tabs" @tab-click="handleTabClick">
      <el-tab-pane label="用户" name="user">
        <el-table :data="userPage.rows" class="record-table"
                  :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                  height="calc(100vh - 350px)"
                  max-height="calc(100vh - 350px)">
          <el-table-column prop="fullName" label="姓名" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="gender" width="100" label="性别" align="center">
            <template slot-scope="scope">{{ scope.row.gender == 1 ? '男' : scope.row.gender == 0 ? '女' : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="电话" align="center"></el-table-column>
          <el-table-column prop="email" label="邮箱" width="200" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="abodeCity" label="所在城市" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="roleNames" label="角色" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="editUserRole(scope.row)" type="text" class="btn" size="small">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            style="margin-top: 8px;"
            class="pagination"
            :hide-on-single-page="true"
            background
            prev-text="Prev"
            next-text="Next"
            @current-change="skipUserPage"
            :current-page="userPage.current"
            :page-size="userPage.size"
            layout="total, prev, pager, next"
            :total="userPage.total">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="医生" name="doctor">
        <el-table :data="doctorPage.rows" class="record-table"
                  :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                  height="calc(100vh - 350px)"
                  max-height="calc(100vh - 350px)">
          <el-table-column prop="fullName" label="姓名" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="gender" label="性别" width="100" align="center">
            <template slot-scope="scope">{{ scope.row.gender == 1 ? '男' : scope.row.gender == 0 ? '女' : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="电话" align="center"></el-table-column>
          <el-table-column prop="email" label="邮箱" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="abodeCity" label="所在城市" align="center"></el-table-column>
          <el-table-column prop="roleNames" label="角色" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button @click="editUserRole(scope.row)" type="text" class="btn" size="small">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination style="margin-top: 8px;"
                       class="pagination"
                       :hide-on-single-page="true"
                       background
                       prev-text="Prev"
                       next-text="Next"
                       @current-change="skipDoctorPage"
                       :current-page="doctorPage.current"
                       :page-size="doctorPage.size"
                       layout="total, prev, pager, next"
                       :total="doctorPage.total">
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="管理员" name="admin">
        <el-table :data="adminPage.rows" class="record-table"
                  :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}"
                  height="calc(100vh - 350px)"
                  max-height="calc(100vh - 350px)">
          <el-table-column prop="userAccount" label="账号" align="center"></el-table-column>
          <el-table-column prop="accountState" label="状态" align="center" width="70">
            <div slot-scope="scope" @click="changeAdminStatus(scope.row)" :data-state="scope.row.accountState">
              {{ scope.row.accountState|statusFmt }}
            </div>
          </el-table-column>
          <el-table-column prop="mobile" label="手机" align="center" width="120"></el-table-column>
          <el-table-column prop="email" label="邮箱" align="center"></el-table-column>
          <el-table-column prop="roleNames" label="角色" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="invalidDate" label="过期时间" align="center" show-overflow-tooltip>
            <div slot-scope="scope">{{ scope.row.invalidDate }}</div>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.userAccount!='admin'" @click="editUserRole(scope.row)" type="text" class="btn"
                         size="small">角色
              </el-button>
              <el-button v-if="scope.row.userAccount!='admin'" @click="editAdmin(scope.row)" type="text" class="btn"
                         size="small">编辑
              </el-button>
              <el-button v-if="scope.row.userAccount!='admin'" @click="resetPassword(scope.row.userId)" type="text"
                         class="btn" size="small">重置密码
              </el-button>
              <el-button v-else-if="curUser=='admin'" @click="resetPassword(scope.row.userId)" type="text" class="btn"
                         size="small">重置密码
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
            style="margin-top: 8px;"
            class="pagination"
            :hide-on-single-page="true"
            background
            prev-text="Prev"
            next-text="Next"
            @current-change="skipAdminPage"
            :current-page="adminPage.current"
            :page-size="adminPage.size"
            layout="total, prev, pager, next"
            :total="adminPage.total">
        </el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!--修改用户权限-->
    <el-drawer :visible.sync="editUserRoleDialog.show" :wrapperClosable="false" :show-close="false"
               @opened="handleUserRoleDialogOpened" title="修改用户权限" size="700px" class="drawerCommon">
      <el-table ref="multipleRoleTable" :data="allRoles" class="record-table" height="calc(100vh - 180px)"
                :header-cell-style="{'background':'rgba(86,123,255,0.1)','color': '#666','fontWeight':'400','textAlign':'center'}">
        <el-table-column type="selection" width="45" align="center"></el-table-column>
        <el-table-column prop="roleCode" label="角色代码" align="center">
          <span slot-scope="scope">{{ scope.row.roleCode.replace("role_", "") }}</span>
        </el-table-column>
        <el-table-column prop="roleName" label="角色名" align="center"></el-table-column>
        <el-table-column prop="roleType" label="类型" width="100" align="center">
          <span slot-scope="scope">{{ scope.row.roleType == 0 ? '系统' : '用户' }}</span>
        </el-table-column>
        <el-table-column prop="remark" label="备注" show-overflow-tooltip align="center"></el-table-column>
      </el-table>
      <div class="footer">
        <el-button style="width: 90px;" size="small" type="primary" @click="saveUserRole" :loading="load.userRole">保存
        </el-button>
        <el-button style="width: 90px;margin-left: 20px" size="small" @click="editUserRoleDialog.show=false">取消
        </el-button>
      </div>
    </el-drawer>
    <!--新增管理员-->
    <el-drawer :visible.sync="addAdminUserDialog.show"  :wrapperClosable="false"
               :show-close="false" title="新增管理员" size="700px" class="drawerCommon">
      <el-form v-model="addAdminUserDialog.form" label-suffix="：" label-width="90px" class="maxHeight">
        <el-form-item label="账号">
          <el-input v-model="addAdminUserDialog.form.userAccount" placeholder="请输入账户名"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input type="password" v-model="addAdminUserDialog.form.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认密码">
          <el-input type="password" v-model="addAdminUserDialog.form.password1" placeholder="请确认密码"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="addAdminUserDialog.form.mobile" placeholder="请输入手机"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="addAdminUserDialog.form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-date-picker type="datetime" v-model="addAdminUserDialog.form.invalidDate"></el-date-picker>
          <span style="margin-left: 10px; vertical-align: text-top; color: #FF9800;"><i class="el-icon-warning-outline">此账户的过期时间：不填写为永久有效</i></span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="5" v-model="addAdminUserDialog.form.remark"></el-input>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button style="width: 90px;" type="primary" size="small" @click="saveAdmin" :loading="load.addAdmin">保存</el-button>
        <el-button style="width: 90px;margin-left: 20px" size="small" @click="addAdminUserDialog.show=false">取消</el-button>
      </div>
    </el-drawer>
    <!--编辑资料-->
    <el-drawer :visible.sync="editAdminUserDialog.show"  :wrapperClosable="false"
               :show-close="false" title="编辑信息" size="700px" class="drawerCommon">
      <el-form v-model="editAdminUserDialog.form" label-suffix="：" label-width="90px" class="maxHeight">
        <el-form-item label="账号">
          <el-input v-model="editAdminUserDialog.form.userAccount" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="手机">
          <el-input v-model="editAdminUserDialog.form.mobile" placeholder="请输入手机"></el-input>
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="editAdminUserDialog.form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="过期时间">
          <el-date-picker type="datetime" v-model="editAdminUserDialog.form.invalidDate"></el-date-picker>
          <span style="margin-left: 10px; vertical-align: text-top; color: #FF9800;"><i class="el-icon-warning-outline">此账户的过期时间：不填写为永久有效</i></span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" :rows="5" v-model="editAdminUserDialog.form.remark"></el-input>
        </el-form-item>
      </el-form>

      <div class="footer">
        <el-button style="width: 90px;" type="primary" size="small" @click="updateAdmin" :loading="load.editAdmin">更新</el-button>
        <el-button style="width: 90px;margin-left: 20px" size="small" @click="editAdminUserDialog.show=false">取消</el-button>
      </div>
    </el-drawer>

    <!--    重置密码-->
    <el-drawer :visible.sync="resetPasswordDialog.show"  :wrapperClosable="false"
               :show-close="false" title="重置密码" size="500px" class="drawerCommon">
      <el-form v-model="resetPasswordDialog.form" label-suffix="：" label-width="100px" class="maxHeight">
        <el-form-item label="新密码">
          <el-input type="password" v-model="resetPasswordDialog.form.password" placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input type="password" v-model="resetPasswordDialog.form.password1" placeholder="请再次输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="验证码" style="position: relative">
          <el-input v-model="resetPasswordDialog.form.code" style="width: 70%;" placeholder="请输入图形验证码"></el-input>
          <img class="codeImg" :src="code.src" alt="验证码" title="验证码" @click="initCaptchaCode">
        </el-form-item>
      </el-form>
      <div class="footer">
        <el-button style="width: 90px;" type="primary" size="small" @click="savePassword" :loading="load.resetPwd">重置</el-button>
        <el-button style="width: 90px;margin-left: 20px" size="small" @click="resetPasswordDialog.show=false">取消</el-button>
      </div>
    </el-drawer>


  </div>
</template>

<script>
import base from '@/api/common';
import qs from "qs";

export default {
  name: "authManage",
  data() {
    return {
      activeTabName: 'user',
      lastTabName: 'user',
      searchKey: '',
      curUser: '',
      userPage: {
        url: base.manager_api.auth.user_role,
        current: 1,
        size: 10,
        total: 9,

        rows: [],
      },
      doctorPage: {
        url: base.manager_api.auth.doctor_role,
        current: 1,
        size: 10,
        total: 9,

        rows: [],
      },
      adminPage: {
        url: base.manager_api.auth.admin_role,
        current: 1,
        size: 10,
        total: 9,

        rows: [],
      },

      allRoles: [],
      editUserRoleDialog: {
        show: false,
        user: {},
      },

      load: {
        userRole: false,
        addAdmin: false,
        editAdmin: false,
        resetPwd: false,
      },

      addAdminUserDialog: {
        show: false,
        form: {
          userAccount: '',
          password: '',
          password1: '',
          mobile: '',
          email: '',
          invalidDate: '',
          remark: ''
        }
      },
      editAdminUserDialog: {
        show: false,
        form: {
          userId: '',
          userAccount: '',
          mobile: '',
          email: '',
          invalidDate: '',
          remark: ''
        }
      },
      resetPasswordDialog: {
        show: false,
        form: {
          userId: '',
          password: '',
          password1: '',
          code: ''
        }
      },
      code: {
        token: '',
        src: ''
      }
    }
  },
  mounted() {
    this.skipPage(1);
    // load all roles
    this.$ajax.get(base.manager_api.auth.role.all).then(res => {
      if (res.data.status === 'success') {
        this.allRoles = res.data.list;
      } else {
        this.$message.error(res.data.message);
      }
    }).catch(err => {
      this.$message.error("角色信息加载失败!");
      console.err(err)
    })
    // set curUser
    this.curUser = localStorage.getItem('curAccount');
  },
  methods: {
    handleTabClick(tab) {
      let tabName = tab.name;
      if (this.activeTabName == this.lastTabName) {
        return;
      }
      this.lastTabName = tabName;
      if (this[tabName + 'Page'].rows.length != 0) {
        return;
      }
      this.skipPage(1);
    },
    skipPage(current) {
      let tab = this.activeTabName;
      if (tab === 'user') {
        this.skipUserPage(current);
      } else if (tab === 'doctor') {
        this.skipDoctorPage(current);
      } else if (tab === 'admin') {
        this.skipAdminPage(current);
      }
    },
    skipUserPage(cur) {
      let that = this;
      this.userPage.current = cur;
      this.$ajax.get(this.userPage.url, {
        params: {
          page: this.userPage.current,
          size: this.userPage.size,
          name: this.searchKey
        }
      }).then(res => {
        if (res.data.status === 'success') {
          that.userPage.current = res.data.current;
          that.userPage.size = res.data.size;
          that.userPage.total = res.data.total;
          that.userPage.rows = res.data.rows;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('信息加载失败')
      })
    },
    skipDoctorPage(cur) {
      let that = this;
      this.doctorPage.current = cur;
      this.$ajax.get(this.doctorPage.url, {
        params: {
          page: this.doctorPage.current,
          size: this.doctorPage.size,
          name: this.searchKey
        }
      }).then(res => {
        if (res.data.status === 'success') {
          that.doctorPage.current = res.data.current;
          that.doctorPage.size = res.data.size;
          that.doctorPage.total = res.data.total;
          that.doctorPage.rows = res.data.rows;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('信息加载失败')
      })
    },
    skipAdminPage(cur) {
      let that = this;
      this.adminPage.current = cur;
      this.$ajax.get(this.adminPage.url, {
        params: {
          page: this.adminPage.current,
          size: this.adminPage.size,
          name: this.searchKey
        }
      }).then(res => {
        if (res.data.status === 'success') {
          that.adminPage.current = res.data.current;
          that.adminPage.size = res.data.size;
          that.adminPage.total = res.data.total;
          that.adminPage.rows = res.data.rows;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch(err => {
        console.error(err);
        that.$message.error('信息加载失败')
      })

    },
    changeAdminStatus(item) {
      if (item.userAccount == 'admin') {
        this.$message.warning("管理员账户不允许修改");
        return;
      }
      let targetStatus = (item.accountState + 1) % 2;
      let msg = "确定要" + (targetStatus == 1 ? '启用' : '禁用') + "吗?";
      this.$messageBox.confirm(msg, '提示', {type: 'warning'}).then(_ => {
        this.$ajax.post(base.manager_api.auth.admin_changeStatus.replace("{id}", item.userId) + "?status=" + targetStatus).then(res => {
          if (res.data.status === 'success') {
            this.$message.success("操作成功");
            item.accountState = targetStatus;
          } else {
            this.$message.error(res.data.message);
          }
        }).catch(err => {
          console.error(err);
          this.$message.error("操作失败");
        });
      });
    },
    addAdmin() {
      // 重置表单数据

      this.addAdminUserDialog.form.userAccount = '';
      this.addAdminUserDialog.form.password = '';
      this.addAdminUserDialog.form.password1 = '';
      this.addAdminUserDialog.form.mobile = '';
      this.addAdminUserDialog.form.email = '';
      this.addAdminUserDialog.form.invalidDate = '';
      this.addAdminUserDialog.form.remark = '';
      this.addAdminUserDialog.show = true;
    },
    editAdmin(item) {
      if (item.userAccount == 'admin') {
        this.$message.warning("管理员账户不允许修改");
        return;
      }
      this.editAdminUserDialog.form.userId = item.userId;
      this.editAdminUserDialog.form.userAccount = item.userAccount;
      this.editAdminUserDialog.form.mobile = item.mobile;
      this.editAdminUserDialog.form.email = item.email;
      this.editAdminUserDialog.form.invalidDate = item.invalidDate;
      this.editAdminUserDialog.form.remark = item.remark;
      this.editAdminUserDialog.show = true;
    },
    saveAdmin() {
      if (!base.reg.account.test(this.addAdminUserDialog.form.userAccount)) {
        this.$message.warning("用户名不合法");
        return;
      }
      if (!base.reg.pass.test(this.addAdminUserDialog.form.password)) {
        this.$message.warning("密码不合法");
        return;
      }
      if (this.addAdminUserDialog.form.password != this.addAdminUserDialog.form.password1) {
        this.$message.warning("两次输入的密码不一致");
        return;
      }
      if ($.trim(this.addAdminUserDialog.form.email).length != 0) {
        if (!base.reg.email.test(this.addAdminUserDialog.form.email)) {
          this.$message.warning("邮箱不合法");
          return;
        }
      }
      if ($.trim(this.addAdminUserDialog.form.mobile).length != 0) {
        if (!base.reg.mobile.test(this.addAdminUserDialog.form.mobile)) {
          this.$message.warning("手机号码不合法");
          return;
        }
      }
      this.load.addAdmin = true;

      let reqData = {
        userAccount: this.addAdminUserDialog.form.userAccount,
        password: this.addAdminUserDialog.form.password,
        mobile: this.addAdminUserDialog.form.mobile,
        email: this.addAdminUserDialog.form.email,
        remark: this.addAdminUserDialog.form.remark,
        invalidDate: '',
      };
      if (this.addAdminUserDialog.form.invalidDate) {
        reqData.invalidDate = new Date(this.addAdminUserDialog.form.invalidDate).Format("yyyy-MM-dd HH:mm:ss");
      }

      this.$ajax.post(base.manager_api.auth.admin_add, reqData).then(res => {
        this.load.addAdmin = false;
        if (res.data.status === 'success') {
          this.$message.success("操作成功");
          this.addAdminUserDialog.show = false;
          this.skipPage(1);
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error("操作失败");
        console.error(err);
      })
    },
    updateAdmin() {
      if ($.trim(this.editAdminUserDialog.form.email).length != 0) {
        if (!base.reg.email.test(this.editAdminUserDialog.form.email)) {
          this.$message.warning("邮箱不合法");
          return;
        }
      }
      if ($.trim(this.editAdminUserDialog.form.mobile).length != 0) {
        if (!base.reg.mobile.test(this.editAdminUserDialog.form.mobile)) {
          this.$message.warning("手机号码不合法");
          return;
        }
      }

      this.load.editAdmin = true;

      let reqData = {
        mobile: this.editAdminUserDialog.form.mobile,
        email: this.editAdminUserDialog.form.email,
        remark: this.editAdminUserDialog.form.remark,
        invalidDate: '',
      };
      if (this.editAdminUserDialog.form.invalidDate != null) {
        reqData.invalidDate = new Date(this.editAdminUserDialog.form.invalidDate).Format("yyyy-MM-dd HH:mm:ss");
      }

      this.$ajax.post(base.manager_api.auth.admin_update.replace("{id}", this.editAdminUserDialog.form.userId), reqData).then(res => {
        this.load.editAdmin = false;
        if (res.data.status === 'success') {
          this.$message.success("操作成功");
          this.editAdminUserDialog.show = false;
          this.skipPage(1);
        } else {
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.$message.error("操作失败");
        console.error(err);
      })
    },
    editUserRole(item) {
      if (item.userAccount == 'admin') {
        this.$message.warning("管理员账户不允许修改");
        return;
      }
      this.editUserRoleDialog.user = item;
      this.editUserRoleDialog.show = true;
    },
    handleUserRoleDialogOpened() {
      let userId = this.editUserRoleDialog.user.id;
      if (this.activeTabName == 'admin') {
        userId = this.editUserRoleDialog.user.userId;
      }
      this.$refs.multipleRoleTable.clearSelection();
      // dialog opened, role 选中渲染
      let roleIds = this.editUserRoleDialog.user.roleIds;
      if (userId && roleIds) {
        let roles = roleIds.split(",");
        $(this.allRoles).each((i, o) => {
          if (roles.includes(o.id + "")) {
            this.$refs.multipleRoleTable.toggleRowSelection(o);
          }
        });
      }
    },
    saveUserRole() {
      let userId = this.editUserRoleDialog.user.id;
      if (this.activeTabName == 'admin') {
        userId = this.editUserRoleDialog.user.userId;
      }

      if (!userId) {
        this.$message.error("操作失败");
        return;
      }
      let roles = this.$refs.multipleRoleTable.selection;

      let reqData = [];
      $(roles).each((i, o) => {
        reqData.push({
          roleId: o.id,
        });
      });
      this.load.userRole = true;
      this.$ajax.post(base.manager_api.auth.role.modify.replace("{id}", userId), reqData).then(res => {
        if (res.data.status === 'success') {
          this.editUserRoleDialog.show = false;
          this.load.userRole = false;
          this.skipPage(1);
          this.$message.success("操作成功");
        } else {
          this.load.userRole = false;
          this.$message.error(res.data.message);
        }
      }).catch(err => {
        this.load.userRole = false;
        this.$message.error("操作失败");
        console.error(err);
      })
    },
    initCaptchaCode() {
      let that = this;
      this.$ajax.post(base.api.captcha).then((res) => {
        if (res.data.status === 'success') {
          that.code.token = res.data.token;
          that.code.src = res.data.data;
        } else {
          that.$message.error(res.data.message);
        }
      }).catch((err) => {
        console.log(err)
        that.$message.error("获取失败");
      });
    },
    resetPassword(id) {
      this.resetPasswordDialog.form.userId = id;
      this.resetPasswordDialog.form.password = '';
      this.resetPasswordDialog.form.password1 = '';
      this.resetPasswordDialog.form.code = '';
      this.initCaptchaCode();
      this.resetPasswordDialog.show = true;
    },
    savePassword() {
      if (!base.reg.pass.test(this.resetPasswordDialog.form.password)) {
        this.$message.warning("新密码不合法: 6-18位字母、数字、下划线组合");
        return;
      }
      if (this.resetPasswordDialog.form.password != this.resetPasswordDialog.form.password1) {
        this.$message.warning("两次输入的密码不一致");
        return;
      }
      if ($.trim(this.resetPasswordDialog.form.code).length != 4) {
        this.$message.warning("验证码错误");
        return;
      }
      this.load.resetPwd = true;
      let id = this.resetPasswordDialog.form.userId;
      let reqData = {
        token: this.code.token,
        code: this.resetPasswordDialog.form.code,
        password: this.resetPasswordDialog.form.password
      };
      this.$ajax.post(base.manager_api.auth.admin_reset_pwd.replace("{id}", id), qs.stringify(reqData)).then(res => {
        this.load.resetPwd = false;
        if (res.data.status === 'success') {
          this.$message.success("操作成功");
          this.resetPasswordDialog.show = false;
        } else {
          this.$message.error(res.data.message);
          this.initCaptchaCode();
        }
      }).catch(err => {
        this.load.resetPwd = false;
        this.$message.error("操作失败");
        this.initCaptchaCode();
      })
    }
  },
  filters: {
    statusFmt(status) {
      if (status == 0) {
        return "禁用";
      } else if (status == 1) {
        return "启用";
      }
      return "-";
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

div[data-state] {
  cursor: pointer
}

div[data-state='1'] {
  color: #a4da89;
  background-color: #f0f9eb;
  border-color: #e1f3d8;
}

div[data-state='0'] {
  color: #f9a7a7;
  background-color: #fef0f0;
  border-color: #fde2e2;
}

button.btn {
  padding: 0
}

img.codeImg {
  position: absolute;
  right: 0;
  top: -4px;
  width: 120px;
  cursor: pointer;
}

</style>